let mPageCache:any;
export function initPageCache(db){
    mPageCache = db.table('pageCache');
}

export function addPageToCache(id,data){
    const item = {
        id,
        pages:data
    }
    const json = JSON.stringify(item);
    mPageCache.put(JSON.parse(json));

    // mPageCache.put({id:'annotations',data:item.pages.annotations});
    // mPageCache.put({id:'arrayLibrarys',data:item.pages.arrayLibrarys});
    // mPageCache.put({id:'arrayWeblinkCache',data:item.pages.arrayWeblinkCache});
    // mPageCache.put({id:'canvas',data:item.pages.canvas[2]});
    // mPageCache.put({id:'info',data:item.pages.info});
    // mPageCache.put({id:'notes',data:item.pages.notes});
    // mPageCache.put({id:'pageSize',data:item.pages.pageSize});
}

export function getPageCacheById(id){
    return mPageCache.get(id);
}